import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import SimpleReactValidator from 'simple-react-validator';
import { withRouter } from 'react-router-dom';
import { saveContactData } from "../../actions/contact"
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'


import { toast } from 'react-toastify';



class Contact extends Component {

    constructor (props) {
        super (props)
        this.state={
            contact_name : '',
            contact_email : '',
            contact_message : '',
            contact_subject : ''


        }
        this.validator = new SimpleReactValidator();

    }

    handleSubmit =(event)=>{

event.preventDefault();
if (this.validator.allValid()) {

     const { connection_id } = this.props
     const options = {
        connection_id:connection_id,
        name:this.state.contact_name,
        email:this.state.contact_email,
        city:"",
        state:"",
        subject:this.state.contact_subject,
        message:this.state.contact_message
     }
   /* this.props.getUserInfo({ ...this.state, auth_type: "R", connection_id })
    this.props.getWebSessionId(connection_id); */
    this.props.saveContactData(options)

    
    setTimeout(function(){
        if (!!!this.props.error) {
            toast.success(" Successful submitted");
           // debugger
            this.props.history.goBack()
        }
    }.bind(this), 500);

} else {
    this.validator.showMessages();
    this.forceUpdate();
}
    }
    handleChange(event) {
        
        this.setState({ [event.target.id]: event.target.value });

    }
    render (){

const {address_details,connection_id} = this.props
        return (
            <div>
                <div className="breadcrumb-section" style={{
    background: 'var(--theme-color)',
    color: 'white'
}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                        <div className="page-title" style={{display:'block',textAlignLast:'center'}}>
                                <div style={{fontSize:15,padding:5}}>Home</div>
                               <h2 style={{fontSize:22,color:'white'}} >CONTACT</h2>
                               </div>
                        </div>
                    </div>
                </div>
            </div>
                
               

                <section className=" contact-page section-b-space">
                    <div className="container">
                       {/*  <div className="row section-b-space">
                            <div className="col-lg-7 map">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d50059.12775918716!2d72.78534673554945!3d21.16564923510817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1533793756956"
                                    allowFullScreen></iframe>
                            </div>
                            <div className="col-lg-5">
                                <div className="contact-right">
                                    <ul>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/phone.png`} alt="Generic placeholder image" />
                                                    <h6>Contact Us</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>+91 123 - 456 - 7890</p>
                                                <p>+86 163 - 451 - 7894</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <i className="fa fa-map-marker" aria-hidden="true"></i>
                                                <h6>Address</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>ABC Complex,Near xyz, New York</p>
                                                <p>USA 123456</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/email.png`} alt="Generic placeholder image" />
                                                    <h6>Address</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>Support@Shopcart.com</p>
                                                <p>info@shopcart.com</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <i className="fa fa-fax" aria-hidden="true"></i>
                                                <h6>Fax</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>Support@Shopcart.com</p>
                                                <p>info@shopcart.com</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        */}
                          {window.innerWidth>560 ?
                         <div className="row">
                            <div className="col">
                               {/*  <form className="theme-form">
                                    <div className="form-row">
                                        <div className="col-md-6">
                                            <label htmlFor="name">First Name</label>
                                            <input type="text" className="form-control" id="name"
                                                   placeholder="Enter Your name" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email">Last Name</label>
                                            <input type="text" className="form-control" id="last-name"
                                                   placeholder="Email" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="review">Phone number</label>
                                            <input type="text" className="form-control" id="review"
                                                   placeholder="Enter your number" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email">Email</label>
                                            <input type="text" className="form-control" id="email" placeholder="Email"
                                                   required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="review">Write Your Message</label>
                                            <textarea className="form-control" placeholder="Write Your Message"
                                  
                                            id="exampleFormControlTextarea1" rows="6"></textarea>
                                        </div>
                                        <div className="col-md-12">
                                            <button className="btn btn-solid" type="submit">Send Your Message</button>
                                        </div>
                                    </div>
                                </form> */}
                                <form>
                                <div className='row'>
                                <div className='col'>

                                <label>Your Name*</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                    <input type='text' id='contact_name'  onChange={(e) => this.handleChange(e)} style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} required/>
                                                    {this.validator.message('Name', this.state.contact_name, 'required|alpha_space')}
    </div>
                                </div><div className='row'>
                                <div className='col'>
                                <label>Your Email*</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                <input type='text' id='contact_email' onChange={(e) => this.handleChange(e)} style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} />
                                                    {this.validator.message('Email', this.state.contact_email, 'required|email')}
    </div>
                                </div><div className='row'>
                                <div className='col'>
                                <label>Subject</label>
                                </div>

                                </div>
                                <div className='row'>
                                <div className='col'>

                                <input type='text' id="contact_subject" onChange={(e) => this.handleChange(e)} style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} /></div>
                                </div><div className='row'>
                                <div className='col'>
                                <label>Your Message</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>

                                <textarea  id="contact_message" onChange={(e) => this.handleChange(e)} style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 100}} ></textarea>
    </div>
                                </div>
                                <div className='row' style={{paddingTop:10}}>
                                <div className='col'>
                                   <button type='submit' className='btn btn-solid' style={{backgroundColor:'red',color:'white'}} onClick={(e)=>this.handleSubmit(e)}>SEND</button>
                                </div>
                                </div>
                                </form>
                            </div>
                            
                            <div className='col'>
                            <div className='row' style={{padding: "30px 0px 13px 25px"}}>
                                <div className='col-1'>
                               
                                <div className='icon'>
                            <i className="fa fa-map-marker" aria-hidden="true" style={{'fontSize': 35}}></i></div>
                                            </div>
                            
                           <div className='col' style={{paddingLeft:10}}>
                                <div>
                                Address :<br/>
                                    {address_details.STE_CORPORATE_ADDRESS1}<br/>{address_details.STE_CORPORATE_STATE_NAME}
                                </div>
                            </div>
                            </div><div className='row' style={{padding:20}}>
                                
                           
                                <div className='col-1'> <i className="fa fa-phone" aria-hidden="true" style={{'fontSize': 35}}></i></div>

                                <div className='col'>   
                                    Phone : <br/>
                                    {address_details.STE_CORPORATE_CONTACT_NO}</div>
                            </div>
                            <div className='row' style={{padding:20}}>
                                <div className='col-1'>
                                <i className="fa fa-envelope" aria-hidden="true" style={{'fontSize': 35}}></i>
                                </div>
                           
                                
                                <div className='col'>Email :<br/>
                                {address_details.STE_CORPORATE_EMAIL_ID}</div>
                            </div>
                            <div className='row'>
                                <div></div>
                            </div>
                        </div>
                        </div>:
                        
                        <div className="row" style={{display:'block'}}>
                            <div className="col">
                             
                                <div className='row'>
                                <div className='col'>

                                <label>Your Name*</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                    <input type='text' style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} />
    </div>
                                </div><div className='row'>
                                <div className='col'>
                                <label>Your Email*</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                <input type='text' style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} /></div>
                                </div><div className='row'>
                                <div className='col'>       <label>Subject</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                <input type='text' style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 35}} /></div>
                                </div><div className='row'>
                                <div className='col'>
                                <label>Your Message</label>
</div>
                                </div>
                                <div className='row'>
                                <div className='col'>
                                <textarea style={{width: '100%',backgroundColor: '#f8f8f8',
    border: 'none',
    height: 100}} ></textarea></div>
                                </div>
                                <div className='row' style={{paddingTop:10}}>
                                <div className='col'>
                                   <button className='btn btn-solid' style={{backgroundColor:'red',color:'white'}}>SEND</button>
                                </div>
</div>
                            </div>
                            <br/>
                            
                            <div className='col'>
                            {/* <div className='row' style={{padding: "30px 0px 13px 25px"}}>
                               
                                <div className='icon'>
                            <i className="fa fa-map-marker" aria-hidden="true" style={{'fontSize': 35}}></i></div>
                                            
                            </div> */}
                           <div className='row' style={{padding:20}}>
                               <div className='col-2'>
                            <i className="fa fa-map-marker" aria-hidden="true" style={{'fontSize': 35}}></i>

                               </div>
                                <div className='col'>
                               <b> Address:</b><br/>
                               {address_details.STE_CORPORATE_ADDRESS1}<br/>{address_details.STE_CORPORATE_STATE_NAME}
                                </div>
                            </div><div className='row' style={{padding:20}}>
                                
                           
                                <div className='col-2'> <i className="fa fa-phone" aria-hidden="true" style={{'fontSize': 35}}></i></div>

                                <div className='col'>   
                                   <b> Phone:</b> <br/>
                                   {address_details.STE_CORPORATE_CONTACT_NO}</div>
                            </div>
                            <div className='row' style={{padding:20}}>
                                <div className='col-2'>
                                <i className="fa fa-envelope" aria-hidden="true" style={{'fontSize': 35}}></i>
                                </div>
                           
                                
                                <div className='col'><b>Email :</b><br/>
                                {address_details.STE_CORPORATE_EMAIL_ID}</div>
                            </div>
                            <div className='row'>
                                <div></div>
                            </div>
                        </div>
                        </div>
                        }
                        
                    </div>

                </section>
<div className="row">
<MapContainer center={[15.317277 ,75.713890]} zoom={5} scrollWheelZoom={false}>
  <TileLayer
    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
 <Marker position={[12.971891, 77.641151]} >
        <Popup>
          Bengalur <br />
        </Popup>
      </Marker>
      
      <Marker position={[13.929930,75.568101]} >
        <Popup>
          Shimoga <br />
        </Popup>
      </Marker>
</MapContainer>
    {/* <iframe 
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818622.0442719073!2d71.39484273609473!3d20.826735394484643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb907075c31d%3A0x25a079cc71cb86ae!2sElement%20-%20Apple%20Exclusive%20Outlet!5e0!3m2!1sen!2sin!4v1597726936517!5m2!1sen!2sin" 
 height="450" frameborder="0" style={{border: 0, pointerEvents: 'none', allowfullscreen:"", ariaHidden:"false", tabindex:0,width:'-webkit-fill-available'}} />
 */}
 
 </div>
           
            </div>
            
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    error: state.user.error,
    connection_id: state.tenant.connection_id,
    address_details : state.tenant.tenant_details,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { saveContactData },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Contact));